import AttachedFilesList from 'components/attached_files_list';
import * as React from 'react';

function AttachedFilesTab(props) {
  const {records} = props;
  return <AttachedFilesList files={records} />;
}

export default AttachedFilesTab;
